var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEaSponsorSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ea-sponsor-search-icon_svg__a",
    d: "M0 0h39.726v39.726H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.663 29.794c0 11.519-9.338 20.856-20.856 20.856-11.519 0-20.856-9.337-20.856-20.856 0-11.518 9.337-20.856 20.856-20.856 11.518 0 20.856 9.338 20.856 20.856",
    fill: "#F8D7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.807 58.596c-13.446 0-25.28-9.52-28.14-22.636l1.941-.423c2.663 12.21 13.681 21.072 26.199 21.072 4.334 0 8.638-1.057 12.449-3.059l.923 1.76a28.864 28.864 0 01-13.372 3.286M54.836 42.139l-1.795-.852a26.575 26.575 0 002.581-11.493c0-11.5-7.312-21.707-18.195-25.4l.638-1.88a28.79 28.79 0 0119.543 27.28c0 4.32-.933 8.473-2.772 12.345",
    fill: "#BBBFC3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    d: "M55.663 60l-24.58-24.578 1.406-1.405 23.174 23.174 2.107-2.107L34.595 31.91 36 30.506l24.579 24.578z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74A10",
    d: "M57.068 51.573L52.15 56.49 33.892 38.23l4.917-4.916z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.297 38.23l16.855 16.855 3.51-3.512L38.81 34.72l-3.512 3.511zm16.855 19.664L32.49 38.23l6.32-6.32 19.663 19.663-6.32 6.32z",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    d: "M37.404 41.742L36 40.337l4.916-4.916 1.404 1.405zM49.343 53.68l-1.405-1.405 4.916-4.916 1.405 1.405z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.733 19.863c0 10.422-8.449 18.87-18.87 18.87-10.422 0-18.87-8.449-18.87-18.87C.993 9.441 9.442.993 19.863.993c10.421 0 18.87 8.448 18.87 18.87",
    fill: "#E8E9EA"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "ea-sponsor-search-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-sponsor-search-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.863 1.986c-9.857 0-17.877 8.02-17.877 17.877s8.02 17.876 17.877 17.876S37.74 29.721 37.74 19.863c0-9.857-8.02-17.877-17.877-17.877m0 37.74C8.91 39.726 0 30.816 0 19.863S8.91 0 19.863 0c10.952 0 19.863 8.91 19.863 19.863 0 10.952-8.91 19.863-19.863 19.863",
    fill: "#020303",
    mask: "url(#ea-sponsor-search-icon_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.758 19.865c0 8.231-6.672 14.903-14.904 14.903-8.23 0-14.902-6.673-14.902-14.903 0-8.231 6.672-14.903 14.903-14.903 8.23 0 14.903 6.672 14.903 14.903",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.855 5.955c-7.67 0-13.91 6.24-13.91 13.91s6.24 13.91 13.91 13.91 13.91-6.24 13.91-13.91-6.24-13.91-13.91-13.91m0 29.806c-8.765 0-15.896-7.132-15.896-15.896 0-8.766 7.131-15.896 15.896-15.896s15.896 7.13 15.896 15.896c0 8.765-7.13 15.896-15.896 15.896",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.065 18.056l-1.954-.359a11.92 11.92 0 0111.731-9.759v1.987a9.935 9.935 0 00-9.777 8.13M25.268 30.562l-.877-1.783a9.983 9.983 0 005.395-7.115l1.953.36a11.98 11.98 0 01-6.47 8.538M8.361 23.112a11.95 11.95 0 01-.447-3.245h1.987c0 .92.125 1.83.372 2.706l-1.912.54z",
    fill: "#020303"
  }))));
}
export default SvgEaSponsorSearchIcon;